<template>
    <div>
        <div style="max-width: 1200px; width: 100%;margin: auto;padding-top: 15px;font-weight: 600;">
            <Breadcrumb-item v-if="detail">保单详情</Breadcrumb-item>
            <Breadcrumb-item v-else>投保信息确认</Breadcrumb-item>
        </div>
        <div class="main">
            <Applicant :info="info" :edit="detail" title="投保企业信息" />
            <div class="mt15 agree" v-if="!detail">
                <Checkbox v-model="agree">我已经阅读并同意</Checkbox>
                <a v-if="eliProductCode" href="/static/pdf/haierProduct/中路财产保险股份有限公司建筑施工人员团体意外伤害保险条款.pdf"
                    target="_blank">《中路财产保险股份有限公司建筑施工人员团体意外伤害保险条款》</a>
                <a v-if="eariProductCode" href="/static/pdf/haierProduct/中路财产保险股份有限公司安装工程一切险条款.pdf" target="_blank">《中路财产保险股份有限公司安装工程一切险条款》</a>
            </div>
            <div class="mt20 center" v-if="!detail">
                <p>实际支付：<span class="price">{{info.totalPremium|NumFormat}}元</span></p>
                <p class="mt10">
                    <Button type="primary" @click="toPay" :disabled="!agree" :loading="loading">立即支付</Button>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
    // import RecognizeInfo from './RecognizeInfo'x
    // import Applicant from './common/Applicant'
    // import InvoiceInfo from './common/InvoiceInfo'
    // import Steps from '../common/Steps'
    // import InsuranceSlip from '../common/InsuranceSlip'
    import Applicant from './common/Applicant'
    import track from "@/mixin/track";
    export default {
        mixins:[track],
        components: { Applicant },
        data () {
            return {
                info: {
                    id: this.$route.params.key,
                },
                loading: false,
                agree: false,
                id: this.$route.params.id,
                eariProductCode: this.$route.query.eariProductCode || '',
                eliProductCode: this.$route.query.eliProductCode || '',
                detail: false,
            }
        },
        created () {
            let path = this.$route.path
            if (path.indexOf('/company-group-employer-yunlifang/confirm') != -1) { //信息确认页面
                this.detail = false
                if (this.id) {
                    this.getInfo()
                }
            } else { // 订单详情页面
                this.detail = true
                this.getDetail()
            }

        },
        mounted(){
            // 回溯 开始录制
            this.$nextTick(this.startRecord);
        },
        methods: {
            // 根据id获取信息
            async getInfo () {
                let res = await this.$axios.post('/cloud-cubic/findPolicyInfo', { projectKey: this.id })
                this.info = res;
                this.getCalculatePremium()
            },
            // 根据id获取信息
            async getDetail () {
                let res = await this.$axios.post('/cloud-cubic/queryPolicyDetail.json', { id: this.id })
                this.info = res;
            },
            async getCalculatePremium () {
                let obj = {
                    coveredArea: this.info.coveredArea,
                }
                if (this.$route.query.eliProductCode) {
                    obj.eliProductCode = this.$route.query.eliProductCode
                }
                if (this.$route.query.eariProductCode) {
                    obj.eariProductCode = this.$route.query.eariProductCode
                }
                console.log('obj打印', obj)
                let res = await this.$axios.post('/cloud-cubic/calculatePremium.json', obj)
                this.info = { ...this.info, ...res }
            },
            async toPay () {
                /*获取投保单*/
                // let insuranceForm = await this.$refs.insurance.val();
                // if(!insuranceForm){
                //     this.toast('请上传投保单','error');
                // 	return
                // }
                // let insurancePolicyUrl=insuranceForm.insurancePolicyUrl.map(item=>{
                // 	return item.insurancePolicyUrl 
                // })
                if (!this.info.projectArea) {
                    this.toast('请选择项目地址省市区', 'error');
                    return
                }
                this.loading = true;
                if (this.$route.query.eariProductCode) {
                    this.info.eariProductCode = this.$route.query.eariProductCode
                }
                if (this.$route.query.eliProductCode) {
                    this.info.eliProductCode = "EMP_LIABILITY_2"
                }
                this.info.InvoiceTaxNo = this.info.subjectIdNo
                // let obj = {
                // 	contactAddress:"1",
                // 	contactEmail:"112312@qq.com",
                // 	contactName:"1",
                // 	contactPhone:"18561953255",
                // 	coveredArea:"80",
                // 	eariPremium:this.info.eariPremium,
                // 	eariProductCode:this.eariProductCode,
                // 	effectiveDateEnd:"2022-09-30 23:59:59",
                // 	effectiveDateStart:"2022-03-30 00:00:00",
                // 	eliPremium:this.info.eliPremium,
                // 	eliProductCode:"EMP_LIABILITY_2",
                // 	invoiceAccount:"1",
                // 	invoiceAddress:"1",
                // 	invoiceBank:"1",
                // 	invoiceName:"1",
                // 	invoicePhone:"1",
                // 	invoiceTaxNo:"1",
                // 	invoiceType:0,
                // 	projectAddress:"1",
                // 	projectCost:0,
                // 	projectKey:"1",
                // 	projectName:"1",
                // 	subjectIdNo:"1",
                // 	subjectName:"1",
                // 	totalPremium:this.info.totalPremium
                // }
                this.$axios.post('/cloud-cubic/savePolicyInfo.all.json', this.info).then(async res => {
                    this.loading = false;
                    if (res.code == 10000000) {
                        // 回溯 停止录制
                        await this.stopRecord({
                            session_key:sessionStorage.track_session_key,
                            policy_id:res.data
                        });
                        window.location.href = `/common.html#/yun-pay?orderNo=${res.data}`
                    } else {
                        this.alert(res.msg);
                    }
                });
            }
        }
    }
</script>
<style scoped lang="less">
    .main {
        background: #fff;
        margin-top: 15px;
        padding: 30px 40px;
    }

    .mt20 {
        font-size: 25px;
        line-height: 1.8;
    }

    span.price {
        color: #FF0000;
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerYunLiFang/Confirm.vue